<template>
  <div class="app-container">
    <wt-form-table :form.sync="form" @on-button-action="onButtonAction">
      <wt-form-table-list ref="violationTableRef" slot="wtFormTableList" :form.sync="form" @on-button-action="onButtonAction">
        <template slot="imgJson" slot-scope="data" v-if="data.row.imgJson !== ''">
          <img class="table-img" v-for="(item, index) in JSON.parse(data.row.imgJson).imageUrl" :src="item" :key="index">
        </template>
        <template slot="status" slot-scope="data">
          <el-tag type="success" v-if="data.row.status === 10">清运完成</el-tag>
          <el-tag type="danger" v-else-if="data.row.status === 5">清运中</el-tag>
          <el-tag type="danger" v-else-if="data.row.status === 7">未处理</el-tag>
          <el-tag type="success" v-else-if="data.row.status === 8">等待清运</el-tag>
          <el-tag type="danger" v-else>系统核查中</el-tag>
        </template>
      </wt-form-table-list>
    </wt-form-table>
  </div>
</template>

<script>

export default {
  data() {
    return {
      imgUrl: window.wtConst.FILE_SERVER_URL,
      open: false,
      dataForm: null,
      form: { //  表单数据
        isFormLoading: false,
        formCode: 'MODULE_VIOLATION_LIST',
        formComponent: {
          list: { type: 'default', value: '/modules/ablHardwareClearLog/dataList' }
        },
        formInputsData: [
          { name: '箱体名称', key: 'boxName', value: '', type: 'text' },
          { name: 'SN', key: 'sn', value: '', type: 'text' },
          { name: '手机号码', key: 'phone', value: '', type: 'text' },
          { name: 'userid', key: 'userId', value: '', type: 'text' },
          { name: 'status', key: 'status', value: '7', type: 'text', hidden: true }
        ],
        formButtonsData: [{ name: '导出Excel',
          key: 'EXPORT',
          action: 'EXCEL',
          url: window.wtConst.BASE_API + '/modules/ablHardwareClearLog/exportExcel',
          fileName: '违规处理',
          permission: 'EXPORT' }],
        formTableData: [
          { name: '公司名称', key: 'companyName' },
          { name: '箱体名称', key: 'boxName', type: 'text' },
          { name: 'SN', key: 'sn', type: 'text' },
          { name: '重量(Kg)', key: 'weight', type: 'text' },
          { name: '清运员', key: 'clearUserName', type: 'text' },
          { name: '违投图片', key: 'imgJson', type: 'custom' },
          { name: '违投原因', key: '', type: 'text' },
          { name: '清运时间', key: 'endClearTime', type: 'text' },
          { name: '状态', key: 'status', type: 'custom' },
          { name: '创建时间', key: 'createdAt', type: 'text' }],
        formTableButtonsData: [
          { name: '投递记录', key: 'VIEW', action: 'VIEW', permission: 'VIEW', className: 'primary' }
        ],
        formResult: {},
        pageData: { currentPage: 0, pageSize: 20, sortName: '', sortOrder: '' },
        formTableProp: { selection: false, buttonHidden: false, index: false }
      }
    }
  },
  methods: {
    /*  ------------------------- 按钮相关  -------------------------  */
    onButtonAction(data) {
      if (data && data.item) {
        if (data.item.action === 'VIEW') {
          // 通过路由跳转到清运记录页面，并传递id作为参数
          this.$router.push({
            name: 'deliveryRecordList',
            query: { sn: data.row.sn }
          })
        }
      }
    }
  }
}
</script>
